<template>
    <div class="login">
        <div class="dowebok">
            <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form">
                <div class="form sign-in">
                    <div class="login-button">
                        <h2>欢迎回来</h2>
                        <el-form-item prop="username">
                            <label>
                                <span>账号</span>
                            </label>
                            <el-input class="input" v-model="loginForm.username" type="text" auto-complete="off"
                                      placeholder="账号">
                                <!--<svg-icon slot="prefix" icon-class="user" class="el-input__icon input-icon"/>-->
                            </el-input>
                        </el-form-item>

                        <el-form-item prop="password">
                            <label>
                                <span>密码</span>
                            </label>
                            <el-input
                                    v-model="loginForm.password"
                                    type="password"
                                    auto-complete="off"
                                    placeholder="密码"
                                    @keyup.enter.native="handleLogin"
                                    show-password
                            >
                                <svg-icon slot="prefix" icon-class="password" class="el-input__icon input-icon"/>
                            </el-input>
                        </el-form-item>

                        <br>
                        <el-button
                                class="submit"
                                :loading="loading"
                                size="medium"
                                type="primary"
                                style="width:100%"
                                @click.native.prevent="handleLogin">
                            <span v-if="!loading">登 录</span>
                            <span v-else>登 录 中...</span>
                        </el-button>
                    </div>
                </div>

                <div class="sub-cont">
                    <div class="img">
                        <div class="img__text m--up">
                            <h2>还未注册？</h2>
                            <p>立即注册，发现大量机会！</p>
                        </div>
                        <router-link to="/register">
                            <div class="img__btn">
                                <span class="m--up">注 册</span>
                            </div>
                        </router-link>
                    </div>
                </div>
            </el-form>
        </div>

        <!--<el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form">-->
        <!--<h3 class="title">登录heq帐号</h3>-->
        <!--<el-form-item prop="username">-->
        <!--<el-input v-model="loginForm.username" type="text" auto-complete="off" placeholder="账号">-->
        <!--<svg-icon slot="prefix" icon-class="user" class="el-input__icon input-icon" />-->
        <!--</el-input>-->
        <!--</el-form-item>-->
        <!--<el-form-item prop="password">-->
        <!--<el-input-->
        <!--v-model="loginForm.password"-->
        <!--type="password"-->
        <!--auto-complete="off"-->
        <!--placeholder="密码"-->
        <!--@keyup.enter.native="handleLogin"-->
        <!--show-password-->
        <!--&gt;-->
        <!--<svg-icon slot="prefix" icon-class="password" class="el-input__icon input-icon" />-->
        <!--</el-input>-->
        <!--</el-form-item>-->
        <!--&lt;!&ndash;            <el-form-item prop="code">-->
        <!--<el-input-->
        <!--v-model="loginForm.code"-->
        <!--auto-complete="off"-->
        <!--placeholder="验证码"-->
        <!--style="width: 63%"-->
        <!--@keyup.enter.native="handleLogin"-->
        <!--&gt;-->
        <!--<svg-icon slot="prefix" icon-class="validCode" class="el-input__icon input-icon" />-->
        <!--</el-input>-->
        <!--<div class="login-code">-->
        <!--<img :src="codeUrl" @click="getCode" class="login-code-img"/>-->
        <!--</div>-->
        <!--</el-form-item>&ndash;&gt;-->
        <!--<el-checkbox v-model="loginForm.rememberMe" style="margin:0px 0px 25px 0px;">记住密码</el-checkbox>-->
        <!--<el-form-item style="width:100%;">-->
        <!--<el-button-->
        <!--:loading="loading"-->
        <!--size="medium"-->
        <!--type="primary"-->
        <!--style="width:100%;"-->
        <!--@click.native.prevent="handleLogin"-->
        <!--&gt;-->
        <!--<span v-if="!loading">登 录</span>-->
        <!--<span v-else>登 录 中...</span>-->
        <!--</el-button>-->
        <!--</el-form-item>-->
        <!--</el-form>-->
    </div>
</template>

<script>
    import Cookies from "js-cookie";
    import {decrypt, encrypt} from "../utils/jsencrypt";

    export default {
        name: "login",
        data() {
            return {
                codeUrl: "",
                cookiePassword: "",
                loginForm: {
                    username: "",
                    password: "",
                    rememberMe: false,
                    code: "",
                    uuid: ""
                },
                loginRules: {
                    username: [
                        {required: true, trigger: "blur", message: "用户名不能为空"}
                    ],
                    password: [
                        {required: true, trigger: "blur", message: "密码不能为空"}
                    ],
                    code: [{required: true, trigger: "change", message: "验证码不能为空"}]
                },
                loading: false,
                redirect: undefined
            };
        },
        created() {
            this.getCookie();
        },
        mounted() {
            let redirect = this.$route.query.redirect;
            this.redirect = redirect
            // console.log("redirect"+redirect)
        },
        methods: {
            getCookie() {
                const username = Cookies.get("username");
                const password = Cookies.get("password");
                const rememberMe = Cookies.get('rememberMe')
                this.loginForm = {
                    username: username === undefined ? this.loginForm.username : username,
                    password: password === undefined ? this.loginForm.password : decrypt(password),
                    rememberMe: rememberMe === undefined ? false : Boolean(rememberMe)
                };
            },
            handleLogin() {
                this.$refs.loginForm.validate(valid => {
                    if (valid) {
                        this.loading = true;
                        if (this.loginForm.rememberMe) {
                            Cookies.set("username", this.loginForm.username, {expires: 30});
                            Cookies.set("password", encrypt(this.loginForm.password), {expires: 30});
                            Cookies.set('rememberMe', this.loginForm.rememberMe, {expires: 30});
                        } else {
                            Cookies.remove("username");
                            Cookies.remove("password");
                            Cookies.remove('rememberMe');
                        }
                        this.$store
                            .dispatch("Login", this.loginForm)
                            .then(response => {
                                if (response.code == 200) {
                                    this.$message({
                                        showClose: true,
                                        message: response.msg,
                                        type: 'success'
                                    });


                                    //根据token获取用户信息
                                    this.$store
                                        .dispatch("getUserInfo")
                                        .then(response => {
                                            if (response.code === 200) {
                                                // this.$message({
                                                //     showClose: true,
                                                //     message: response.msg,
                                                //     type: 'success'
                                                // });
                                                // this.$router.push({ path: this.redirect || "/" });
                                            } else {
                                                this.$message({
                                                    showClose: true,
                                                    message: response.msg,
                                                    type: 'error'
                                                });
                                                this.loading = false;
                                            }
                                        })
                                        .catch((error) => {
                                            this.$message({
                                                showClose: true,
                                                message: error.msg,
                                                type: 'error'
                                            });
                                            this.loading = false;
                                        });

                                    // setTimeout(() =>{
                                    //     this.$router.push({ path: this.redirect || "/" });
                                    //     location.reload();
                                    // },1000);

                                    // 登录成功之后的跳转
                                    setTimeout(() => {
                                        if (this.redirect) {
                                            //如果是从注册跳到登录，登录成功后跳到首页
                                            if (this.redirect === "/register"){
                                                location.href = "/"
                                            } else {
                                                location.href = this.redirect
                                            }
                                        } else {
                                            location.href = "/"
                                        }
                                    }, 1000);

                                } else {
                                    this.$message({
                                        showClose: true,
                                        message: response.msg,
                                        type: 'error'
                                    });
                                    this.loading = false;
                                }
                            })
                            .catch(() => {
                                this.loading = false;
                                // this.getCode();
                            });
                    }
                });
            }
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss">
    .login {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        /*background-image: url("../assets/image/login-background.jpg");*/
        /*background: #cccccc;*/
        background-size: cover;
    }

    .login-button{
        width: 50%;
        margin: 0 auto !important;
    }

    .title {
        margin: 0px auto 30px auto;
        text-align: center;
        color: #707070;
    }

    .login-form {
        border-radius: 6px;
        /*background: #ffffff;*/
        /*background: #e9f5ff;*/
        width: 400px;
        padding: 25px 25px 5px 25px;
        .el-input {
            height: 38px;
            input {
                height: 38px;
            }
        }
        .input-icon {
            height: 39px;
            width: 14px;
            margin-left: 2px;
        }
    }

    .login-tip {
        font-size: 13px;
        text-align: center;
        color: #bfbfbf;
    }

    .login-code {
        width: 33%;
        height: 38px;
        float: right;
        img {
            cursor: pointer;
            vertical-align: middle;
        }
    }

    .el-login-footer {
        height: 40px;
        line-height: 40px;
        position: fixed;
        bottom: 0;
        width: 100%;
        text-align: center;
        color: #fff;
        font-family: Arial;
        font-size: 12px;
        letter-spacing: 1px;
    }

    .login-code-img {
        height: 38px;
    }
</style>


<style scoped>
    *, *:before, *:after {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
    }

    body {
        /*font-family: 'Open Sans', Helvetica, Arial, sans-serif;*/
        background: #ededed;
    }

    input, button {
        border: none;
        outline: none;
        background: none;
        font-family: 'Open Sans', Helvetica, Arial, sans-serif;
    }

    .tip {
        font-size: 20px;
        margin: 40px auto 50px;
        text-align: center;
    }

    .dowebok {
        overflow: hidden;
        position: relative;
        /*position: absolute;*/
        /*left: 50%;*/
        /*top: 50%;*/
        width: 900px;
        height: 550px;
        margin: 100px auto;
        /*margin: -300px 0 0 -450px;*/
        background: #fff;
    }

    .form {
        position: relative;
        width: 640px;
        height: 100%;
        padding: 50px 30px;
    }

    .sub-cont {
        overflow: hidden;
        position: absolute;
        left: 640px;
        top: 0;
        width: 900px;
        height: 100%;
        padding-left: 260px;
        background: #fff;
    }

    button {
        display: block;
        margin: 0 auto;
        width: 260px;
        height: 36px;
        border-radius: 30px;
        color: #fff;
        font-size: 15px;
        cursor: pointer;
    }

    .img {
        overflow: hidden;
        z-index: 2;
        position: absolute;
        left: 0;
        top: 0;
        width: 260px;
        height: 100%;
        padding-top: 360px;
    }

    .img:before {
        content: '';
        position: absolute;
        right: 0;
        top: 0;
        width: 900px;
        height: 100%;
        /*background-image: url(../images/bg.jpg);*/
        background-size: cover;
    }

    .img:after {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.6);
    }

    .img__text {
        z-index: 2;
        position: absolute;
        left: 0;
        top: 50px;
        width: 100%;
        padding: 0 20px;
        text-align: center;
        color: #fff;
    }

    .img__text h2 {
        margin-bottom: 10px;
        font-weight: normal;
    }

    .img__btn {
        overflow: hidden;
        z-index: 2;
        position: relative;
        width: 100px;
        height: 36px;
        margin: 0 auto;
        background: transparent;
        color: #fff;
        text-transform: uppercase;
        font-size: 15px;
        cursor: pointer;
    }

    .img__btn:after {
        content: '';
        z-index: 2;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        border: 2px solid #fff;
        border-radius: 30px;
    }

    .img__btn span {
        position: absolute;
        left: 0;
        top: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
    }

    h2 {
        width: 100%;
        font-size: 26px;
        text-align: center;
    }

    label {
        display: block;
        width: 260px;
        margin: 50px auto 0;
        text-align: center;
    }

    label span {
        font-size: 12px;
        color: #909399;
        text-transform: uppercase;
    }

    .input {
        display: block;
        width: 100%;
        margin-top: 5px;
        padding-bottom: 5px;
        font-size: 16px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.4);
        text-align: center;
    }

    .forgot-pass {
        margin-top: 15px;
        text-align: center;
        font-size: 12px;
        color: #cfcfcf;
    }

    .forgot-pass a {
        color: #cfcfcf;
    }

    .submit {
        margin-top: 40px;
        margin-bottom: 20px;
        background: #d4af7a;
        text-transform: uppercase;
    }

    .fb-btn {
        border: 2px solid #d3dae9;
        color: #8fa1c7;
    }

    .fb-btn span {
        font-weight: bold;
        color: #455a81;
    }
</style>

